import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CaoService } from 'src/app/services/cao.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import saveAs from 'file-saver';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';

@Component({
  selector: 'app-epc-generated-lot-upload-tax',
  templateUrl: './epc-generated-lot-upload-tax.component.html',
  styleUrls: ['./epc-generated-lot-upload-tax.component.scss'],
  providers: [DatePipe]
})
export class EpcGeneratedLotUploadTaxComponent implements OnInit {

  public selectedContractor: any;
  public contractorList: any = [];
  public showDetailTable: boolean = false;

  public userId: any;
  public date: any;
  public loading: boolean = false;

  public lotTableData: any = [];

  public subscriptions: any = []
  public subjectSub: any;

  public openDialog: boolean = false;
  public selectedLotNo: any;
  public ipAddress: any = '000.000.000';

  constructor(
    private loader: AppLoaderService,
    private activityRecordService: ActivityRecordService,
    private deptDashBoardService: DepartmentDashboardService,
    private messageService: MessageService,
    // private route: ActivatedRoute,
    private cryptoJsService: CryptoJsService,
    private ipService: IpAddressService,
    private datePipe: DatePipe,
    // public cd: ChangeDetectorRef,
    // public router: Router,
    // private service: BaseService,
    private vendorService: VendorDashboardService,
    private _personalDetalSer: FarmersDetailsService,
  ) { }

  ngOnInit(): void {
    this.date = this.datePipe.transform(new Date(), 'yyyy-MM-dd');

    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.loadContractor(this.userId);
  }

  loadContractor(userId) { 
    this.loader.start();
    let sub = this.vendorService
    .getContractorMaster(userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();          
          if (data.length > 0) {
            this.contractorList = data;
          }
          else {
            this.contractorList = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
        },
        error: (err) => {
          this.loader.close(); 
          this.contractorList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  onSelectContractor() {
    if (this.selectedContractor) {
      this.showDetailTable = true;
      this.loadData(this.selectedContractor?.ContractorCode, this.userId);
    }
  }

  refreshTable() {
    if(this.selectedContractor){
      this.loadData(this.selectedContractor?.ContractorCode, this.userId);
    }
  }

  loadData(contractorId, userId) {
    // this.loader.start();
    this.loading = true;
    let sub = this.deptDashBoardService
      .getAppsForLotPFMSEPC(contractorId, userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;

          if (data.length > 0) {
            this.lotTableData = data;
          }
          else {
            this.lotTableData = [];

            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }

        },
        error: (err) => {
          this.loading = false;
          this.lotTableData = [];

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  hideDialog(){
    this.openDialog = false;
    this.selectedLotNo = null;
  }

  onClickUpload(row){
    this.selectedLotNo = row?.Lot_No;
    this.openDialog = true;
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }
}
